import React, { useState } from 'react';

import { USER_DATA_ANIMATION } from './animations';

import { useAuth } from '../../../hooks/AuthContext';

import { Container } from './styles';

import TalentsTable from '../../../components/TalentsTable';
import DefaultHeader from '../../../components/DefaultHeader';
import TalentsModal from '../../../components/TalentsModal';

import { isAdminOrRecrutier } from '../../../utils';

const Opportunity = ({ setIsOpened }) => {
  const [isOpened, setIsOpenend] = useState(false);
  const [isModalType, setModalType] = useState('New');
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedItem, setSelectedItem] = useState([]);
  const [hasChange, setHasChange] = useState(false);

  const { user } = useAuth() as any;

  const userIsAdminOrRecruiter =
    user.roles || user.role ? isAdminOrRecrutier(user) : false;

  function handleSearchQuery(query) {
    setSearchQuery(query.toLowerCase().trim());
  }

  function handleNewClick() {
    setIsOpenend(!isOpened);
  }

  if (userIsAdminOrRecruiter) {
    return (
      <>
        <Container variants={USER_DATA_ANIMATION}>
          <DefaultHeader
            onNewClick={() => {
              setModalType('New');
              handleNewClick();
            }}
            title="Talentos"
            buttonTitle="Novo Talento"
            setIsOpened={setIsOpened}
            handleSearchQuery={handleSearchQuery}
          />

          <TalentsTable
            searchQuery={searchQuery}
            setModalType={type => {
              setModalType(type);
              handleNewClick();
            }}
            setSelectedItem={setSelectedItem}
            selectedItem={selectedItem}
            handleChange={hasChange}
          />
        </Container>

        <TalentsModal
          modalType={isModalType}
          isOpened={isOpened}
          toggleChildOpen={handleNewClick}
          selectedItem={selectedItem}
          handleChange={() => {
            setHasChange(!hasChange);
          }}
        />
      </>
    );
  }

  return <></>;
};

export default Opportunity;
